import React, { Component } from 'react';
import SelectionBox from './SelectionBox';
import ScoreSlider from './Slider/ScoreSlider';
import './ScoreBox.css';

// Different from ScoreBox, this component directly reflect input properties' values
export default class ScoreBox2 extends Component {
    constructor(props) {
        super(props);
        // this.handleSelectionBoxChange = this.handleSelectionBoxChange.bind(this);
        // this.handleScoreSliderChange = this.handleScoreSliderChange.bind(this);

        this.state = {
        }
    }
    handleSelectionBoxChange = (name, value, ischecked) => {
        // this.setState({ disabled: !ischecked });
        this.props.onScoreBoxChange(this.props.index, !ischecked, this.props.data.value);
    }
    handleScoreSliderChange = (value) => {
        // this.setState({ value });
        this.props.onScoreBoxChange(this.props.index, this.props.data.disabled, value);
    }
    render() {
        return (
            <div className="ScoreBox">
                <SelectionBox label={this.props.label} name={this.props.name} tooltip={this.props.tooltip} onChange={this.handleSelectionBoxChange} ischecked={!this.props.data.disabled} />
                <ScoreSlider disabled={this.props.data.disabled} value={this.props.data.value} onChange={this.handleScoreSliderChange} />
            </div>
        )
    }
}